module.exports = __webpack_public_path__ + "img/location.a3942fb3.png";